import { BodyOfWaterConfig, DeviceConfig, DeviceTypes, HardwareConfig, HardwareConfigRecord, PortConfig, PortTypeValues, WaterLevelSensorSettingsInterlockActivationStates } from "./documents/HardwareConfig";
import { DesiredStateConfig, DesiredStateRecord } from "./documents/DesiredState";
import { ScheduleConfig, ScheduleRecord } from "./documents/Schedule";
import { ThemesConfig, ThemesRecord } from "./documents/Themes";
import { ThemeMacrosConfig, ThemeMacrosRecord } from "./documents/ThemeMacros";
import { EnergyRatesConfig, EnergyRatesRecord } from "./documents/EnergyRates";
import { ChemistryConfig, ChemistryRecord, SanitizerTypes, BowChemistry, ChemistryEdit } from "./documents/Chemistry";
import { ButtonMappingsConfig, ButtonMappingsRecord } from "./documents/ButtonMappings";
import { PaletteConfig, PaletteRecord } from "./documents/Palette";
import { BodyOfWaterUserSettingsConfig, BodyOfWaterUserSettingsRecord, BowAutofillSettingsActions } from "./documents/BodyOfWaterUserSettings";
import { ConfigRecord } from "./documents/ConfigRecord";
import { dataSource } from "../../lib/Functions";
import { SiteRecord } from "./records/Site";
import migrateChemistryConfig from "./functions/migration/chemistry";
import migrateHardwareConfig from "./functions/migration/hardware";
import migrateScheduleConfig from "./functions/migration/schedule";
import Locale from "../utils/Locale";
import { PlatformCapabilities, PlatformCapabilitiesModulesPortTypes } from "../status"
import { getChlorineSensorType } from "./functions/Device";
import { ChlorineSensorSensorTypes } from "../catalog";
import { safeObjCopy, safeArrCopy, safeJsonParse } from "../utils/Json";
import { isSet, PoolsideError } from "../utils";
import { SaltChlorineDispenseMethods, CoreParams } from "../types";
import { PortUsage, PortUsageBusClasses, PortUsageInvalidAddressesByAddressUiqueType, PortUsagePortBookingType, PortUsagePortsBus, PortUsagePortsRelay } from "./Types";
export * from './Types';
export {
    getChemistryConfigBackwardCompatible,
    getDefaultSanitizerAlertTooHighTargetByType,
    getDefaultSanitizerAlertTooLowTargetByType,
    getDefaultSanitizerTargetByType,
    migrateChemistryConfigUsingState,
} from "./functions/migration/chemistry";
import {
    getDefaultSanitizerAlertTooHighTargetByType,
    getDefaultSanitizerAlertTooLowTargetByType,
    getDefaultSanitizerTargetByType
} from "./functions/migration/chemistry";
import { MissingCoreParamsError } from "../utils";
import Logger from "../utils/Logger";
import * as Catalog from "../catalog";


export type ConfigFileNames = 
"Config.json" | "DesiredState.json" | "Schedule.json" | "Themes.json" |  "ThemeMacros.json" | 
"EnergyRates.json" | "HeatingStats.json" | "Palette.json" | "Chemistry.json" | "ButtonMappings.json" |
"BodyOfWaterUserSettings.json" | 
"NotificationSettings.json" | "NotificationProfiles.json";

export enum ConfigRecordFileNames {
    HardwareConfig = "Config.json",
    DesiredState = "DesiredState.json",
    Schedule = "Schedule.json",
    Themes = "Themes.json",
    ThemeMacros = "ThemeMacros.json",
    EnergyRates = "EnergyRates.json",
    HeatingStats = "HeatingStats.json",
    Palette = "Palette.json",
    Chemistry = "Chemistry.json",
    ButtonMappings = "ButtonMappings.json",
    BodyOfWaterUserSettings = "BodyOfWaterUserSettings.json",
    NotificationProfiles = 'NotificationProfiles.json',
};

export * from "./documents/BodyOfWaterUserSettings";
export * from "./documents/ButtonMappings";
export * from "./documents/Chemistry";
export * from "./documents/ConfigRecord";
export * from "./documents/DesiredState";
export * from "./documents/EnergyRates";
export * from "./documents/HardwareConfig";
//export * from "./documents/HeatingStats";
export * from "./documents/Palette";
export * from "./documents/Schedule";
export * from "./documents/ThemeMacros";
export * from "./documents/Themes";
export * from "./records/Site";
export * from "./records/User";
export * from "./records/Permission";
export * from "./records/State";
export * from "./records/Token";
export * from "./functions/Control";
export * from "./functions/Device";
export * from "./functions/Flow";
export * from "./functions/Localization";

export function AllFromList(list:ConfigRecord<object>[]):AllConfig {
    let allConf = new AllConfig();
    
    allConf.Config = (list.find(rec => rec.fileName === ConfigRecordFileNames.HardwareConfig) as HardwareConfigRecord)?.data;
    allConf.DesiredState = (list.find(rec => rec.fileName === ConfigRecordFileNames.DesiredState) as DesiredStateRecord)?.data;
    allConf.Schedule = (list.find(rec => rec.fileName === ConfigRecordFileNames.Schedule) as ScheduleRecord)?.data;
    allConf.Themes = (list.find(rec => rec.fileName === ConfigRecordFileNames.Themes) as ThemesRecord)?.data;
    allConf.ThemeMacros = (list.find(rec => rec.fileName === ConfigRecordFileNames.ThemeMacros) as ThemeMacrosRecord)?.data;
    allConf.EnergyRates = (list.find(rec => rec.fileName === ConfigRecordFileNames.EnergyRates) as EnergyRatesRecord)?.data;
    //allConf.HeatingStats = (list.find(rec => rec.fileName === ConfigRecordFileNames.HeatingStats) as HardwareConfigRecord)?.data;
    allConf.Palette = (list.find(rec => rec.fileName === ConfigRecordFileNames.Palette) as PaletteRecord)?.data;
    allConf.Chemistry = (list.find(rec => rec.fileName === ConfigRecordFileNames.Chemistry) as ChemistryRecord)?.data;
    allConf.ButtonMappings = (list.find(rec => rec.fileName === ConfigRecordFileNames.ButtonMappings) as ButtonMappingsRecord)?.data;
    allConf.BodyOfWaterUserSettings = (list.find(rec => rec.fileName === ConfigRecordFileNames.BodyOfWaterUserSettings) as BodyOfWaterUserSettingsRecord)?.data;

    return allConf;
}

export function AllFromCollection(coll:ConfigCollection):AllConfig {
    let allConf = new AllConfig();
    allConf.Config = coll.Config?.data || null;
    allConf.DesiredState = coll.DesiredState?.data || null;
    allConf.Schedule = coll.Schedule?.data || null;
    allConf.Themes = coll.Themes?.data || null;
    allConf.ThemeMacros = coll.ThemeMacros?.data || null;
    allConf.EnergyRates = coll.EnergyRates?.data || null;
    //allConf.HeatingStats = coll.HeatingStats?.data;
    allConf.Palette = coll.Palette?.data || null;
    allConf.Chemistry = coll.Chemistry?.data || null;
    allConf.ButtonMappings = coll.ButtonMappings?.data || null;
    allConf.BodyOfWaterUserSettings = coll.BodyOfWaterUserSettings?.data || null;

    return allConf;
}

export class ConfigCollection {
    Config: HardwareConfigRecord = null;
    DesiredState: DesiredStateRecord = null;
    Schedule: ScheduleRecord = null;
    Themes: ThemesRecord = null;
    ThemeMacros: ThemeMacrosRecord = null;
    EnergyRates: EnergyRatesRecord = null;
    //HeatingStats: HeatingStatsRecord = null;
    Palette: PaletteRecord = null;
    Chemistry: ChemistryRecord = null;
    ButtonMappings: ButtonMappingsRecord = null;
    BodyOfWaterUserSettings: BodyOfWaterUserSettingsRecord = null;
};

export class AllConfig {
    Config: HardwareConfig = null;
    DesiredState: DesiredStateConfig = null;
    Schedule: ScheduleConfig = null;
    Themes: ThemesConfig = null;
    ThemeMacros: ThemeMacrosConfig = null;
    EnergyRates: EnergyRatesConfig = null;
    //HeatingStats: HeatingStatsConfig = null;
    Palette: PaletteConfig = null;
    Chemistry: ChemistryConfig = null;
    ButtonMappings: ButtonMappingsConfig = null;
    BodyOfWaterUserSettings: BodyOfWaterUserSettingsConfig = null;
};

export function findBody(uuid:string, conf:HardwareConfig) {
    return conf.BodiesOfWater.find(item => item.UUID === uuid);
}

export function findControl(uuid:string, conf:HardwareConfig) {
    return conf.Controls.find(item => item.UUID === uuid);
}

export function findDevice(uuid:string, conf:HardwareConfig) {
    return conf.Devices.find(item => item.UUID === uuid);
}

export const defaults = {
    defaultHeatingTempMin: 40,
    defaultHeatingTempMax: 104,
    defaultHeatingTemp: 80,
    defaultFreezeProtectActivatingTemp: 40,
}

export const defaultConfigs = {
    'Config.json': {
        siteId: -1,
        fileName: 'Config.json',
        data: { // type of ConfigDataMain
            FreezeProtect: {
                Mode: 'ENABLED',
                MinSpeed: 100,
                ActivatingTemperature: defaults.defaultFreezeProtectActivatingTemp
            },
            Ambient: {},
            Location: {
                UUID: null,
                Name: "Unregistered",
                Address: "",
                City: "",
                State: "",
                Latitude: 0,
                Longitude: 0
            },
            BodiesOfWater: [],
            Controls: [],
            ControlGroups: [],
            Controllers: [],
            Devices: [],
            Flows: [],
            WaterFeatures: [],
            CombinedControls: []
        }
    } as HardwareConfigRecord,
    'DesiredState.json': {
        siteId: -1,
        fileName: 'DesiredState.json',
        data: []
    },
    [ ConfigRecordFileNames.Schedule ]: {
        siteId: -1,
        fileName: ConfigRecordFileNames.Schedule,
        data: { // type of ConfigDataSchedule
            'Schedule': []
        }
    },
    'Themes.json': {
        siteId: -1,
        fileName: 'Themes.json',
        data: [] // type of ConfigDataThemes
    },
    'ThemeMacros.json': {
        siteId: -1,
        fileName: 'ThemeMacros.json',
        data: [] // type of ConfigDataThemes
    },
    'EnergyRates.json': {
        fileName: "EnergyRates.json",
        data: new EnergyRatesConfig()
    },
    'Palette.json': {
        fileName: 'Palette.json',
        data: {
            colors: []
        }
    },
    'Chemistry.json': {
        fileName: 'Chemistry.json',
        data: []
    },
    'ButtonMappings.json': {
        fileName: 'ButtonMappings.json',
        data: []
    },
    'BodyOfWaterUserSettings.json': {
        fileName: 'BodyOfWaterUserSettings.json',
        data: [
            
        ]
    }
};

/**
* @typedef ConnectedThing
* @property {string} UUID E.g: "f63f5b52-f2b2-4735-a693-bdd7e5d7541a",
* @property {Array<ConnectedThing>} ConnectedThings
*/

export async function fixAllConfig (allConfig) {
    // Getting states for all sites related to the configs
    const siteIds = [];

    allConfig.forEach(config => {
        if (!siteIds.includes(config.siteId)) {
            siteIds.push(config.siteId);
        }
    });

    await Promise.all(
        siteIds.map(async siteId => {
            let siteRec = dataSource.getSite(siteId);
            let siteStates = dataSource.getSiteStates(false, siteRec);
            Object.keys(siteStates).length === 0 ?
                await dataSource.getState(siteId) : 
                true;
        })
    );

    allConfig?.forEach(config => {
        const siteRecord = dataSource.getSite(config.siteId);
        const siteStates = dataSource.getSiteStates(true, siteRecord);

        // Migrate very old config version
        if (config?.data?.data) 
            delete config.data.data;
 
        // Append missing config props.
        // Helps to avoid human errors when we try to access a new config prop while working with old config and forget using the ? operator...
        if (typeof config?.data === "object" && !Array.isArray(config.data) && defaultConfigs[config.fileName]?.data)
            config.data = Object.assign(JSON.parse(JSON.stringify(defaultConfigs[config.fileName].data)), config.data);

        switch (config.fileName) {
        case ConfigRecordFileNames.Chemistry: migrateChemistryConfig(config); break;
        case ConfigRecordFileNames.HardwareConfig: migrateHardwareConfig(config, siteStates); break;
        case ConfigRecordFileNames.Schedule: migrateScheduleConfig(config); break;
        }
    });
 }
 
 export class SiteConfigSnapshot {
    Name?:string;
    Site:SiteRecord;
    Configurations:AllConfig;
    AwayMode:any;
    Created?:Date;

    constructor() {
        this.Created = new Date();
    }
}

 export function getSanitizerTypeLocalized(sanitizerType: SanitizerTypes): string {
    switch(sanitizerType) {
    case SanitizerTypes.FREE_CHLORINE: return Locale.gettext("Free Chlorine");
    case SanitizerTypes.ORP: return Locale.gettext("ORP");
    case SanitizerTypes.TOTAL_CHLORINE: return Locale.gettext("Total Chlorine");
    default: return sanitizerType;
    }
}

/**
 * Returns localised version of port type
 * that should match labels on printed on the real hardware.
 * @param {string} type PortType of HardwareConfig or PlatformCapabilities
 * @returns {string}
 */
export function getPortTypeLocalised (type: PortTypeValues | string): string {
    switch (type) {
    case PortTypeValues.Actuator: return Locale.gettext('Valve');
    case PortTypeValues.Bluetooth: return 'Bluetooth';
    case PortTypeValues.HighVoltage: return Locale.gettext('Relay');
    case PortTypeValues.LightDriverLowVoltage: return Locale.gettext("Light Driver Low Voltage");
    case PortTypeValues.LowVoltage: return Locale.gettext('Heater');
    case PlatformCapabilitiesModulesPortTypes.Bus:
    case PortTypeValues.Serial: return Locale.gettext('Bus');
    case PlatformCapabilitiesModulesPortTypes.FlowSwitch:
    case PortTypeValues.Switch: return Locale.gettext('Flow Switch');
    case PortTypeValues.Thermistor: return Locale.gettext('Temp Sensor');
    case PlatformCapabilitiesModulesPortTypes.Ma:
    case PortTypeValues.Chemistry420: return Locale.gettext("Chem 4-20mA");
    case PortTypeValues.ChemistryORP: return Locale.gettext('Chem ORP');
    case PortTypeValues.ChemistryPH: return Locale.gettext('Chem PH');
    default: return type;
    }
}

export function getWaterLevelSensorSettingsInterlockActivationStateLocalized(value: WaterLevelSensorSettingsInterlockActivationStates): string {
    switch(value) {
    case WaterLevelSensorSettingsInterlockActivationStates.DISABLED: return Locale.gettext("Disabled");
    case WaterLevelSensorSettingsInterlockActivationStates.IN_WATER: return Locale.gettext("In water");
    case WaterLevelSensorSettingsInterlockActivationStates.OUT_OF_WATER: return Locale.gettext("Out of water");
    default: return value;
    }
}

export function getBowAutofillSettingsActionLocalized(value: BowAutofillSettingsActions): string {
    switch(value) {
    case BowAutofillSettingsActions.ACTION: return Locale.gettext('Action & Alert');
    case BowAutofillSettingsActions.ALERT_ONLY: return Locale.gettext("Alert Only");
    default: return value;
    }
}

export function getChlorineSensorTypeLocalized(config: DeviceConfig): string {
    const sensorType = getChlorineSensorType(config);
    switch(sensorType) {
    case ChlorineSensorSensorTypes.FREE_CHLORINE: return Locale.gettext("Free");
    case ChlorineSensorSensorTypes.TOTAL_CHLORINE: return Locale.gettext("Total");
    }
}

export function translateChemistryConfigFromAppToController (record: BowChemistry, autoFilterVersion: number, chemistryEdit: ChemistryEdit) {
    const recordCopy = safeObjCopy(record);
    
    if (recordCopy.AcidDosingProcedureUseDefault) {
        recordCopy.AcidDosingProcedure = autoFilterVersion >= 34 ?
            null :
            chemistryEdit.DefaultAcidDosingProcedure
        ;
    }
    if (recordCopy.BaseDosingProcedureUseDefault) {
        recordCopy.BaseDosingProcedure = autoFilterVersion >= 34 ?
            null :
            chemistryEdit.DefaultBaseDosingProcedure
        ;
    }
    if (recordCopy.CO2DosingProcedureUseDefault) {
        recordCopy.CO2DosingProcedure = autoFilterVersion >= 34 ?
            null :
            chemistryEdit.DefaultCO2DosingProcedure
        ;
    }
    if (recordCopy.LiquidChlorineDosingProcedureUseDefault) {
        recordCopy.LiquidChlorineDosingProcedure = autoFilterVersion >= 34 ?
            null :
            chemistryEdit.DefaultLiquidChlorineDosingProcedure
        ;
    }
    if (recordCopy.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault) {
        recordCopy.SaltChlorineDosing.NotCovered.DosingRows = autoFilterVersion >= 34 ?
            null :
            chemistryEdit.DefaultSaltDosingProcedure?.NotCovered?.DosingRows
        ;
    }
    if (recordCopy.SaltChlorineDosing?.Covered?.DosingRowsUseDefault) {
        recordCopy.SaltChlorineDosing.Covered.DosingRows = autoFilterVersion >= 34 ?
            null :
            (
                chemistryEdit.DefaultSaltDosingProcedure?.Covered?.DosingRows
                ?? chemistryEdit.DefaultSaltDosingProcedure?.NotCovered?.DosingRows
            )
        ;
    }

    return recordCopy;
}

/**
 * Tells if the system supports pH target. Can be used to show/hide Sanitiizer target configuration for the user .
 */
export function isSanitizerTargetAndAlertsAvailable(chemistryEdit: ChemistryEdit, chemistryVersion: number, configData: HardwareConfig) {
    if (chemistryVersion >= 6) {
        return (chemistryEdit.SanitizerSensor || chemistryEdit.ORPProbe);
    } else {
        const hasOrpProbe = configData?.Devices?.some(itm => itm.DeviceType === DeviceTypes.ORPPROBE);
        return hasOrpProbe;
    }
}

/**
 * Tells if the system supports pH target. Can be used to show/hide pH target configuration for the user .
 */
export function isPhTargetAndAlertsAvailable(chemistryEdit: ChemistryEdit, chemistryVersion: number, configData: HardwareConfig) {
    if (chemistryVersion >= 6) {
        return chemistryEdit.PhProbe;
    } else {
        const hasPhProbe = configData?.Devices?.some(itm => itm.DeviceType === DeviceTypes.PHPROBE);
        return hasPhProbe;
    }
}

/**
 * Makes sure the desired pH target and/or sanitizer target could be met by the configured dosing tables.
 * Returns array of localized error strings on errors. Falsy value otherwise.
 */
export function validateDosingProcedure (chemistry: BowChemistry): Array<string> {
    const errors = [];

    if (chemistry.DispensingAcidEnabled &&
        !chemistry.AcidDosingProcedureUseDefault && (
            !chemistry.AcidDosingProcedure?.DosingRows?.length ||
            chemistry.AcidDosingProcedure.DosingRows[ 0 ].FromValue > chemistry.PHTarget ||
            chemistry.AcidDosingProcedure.DosingRows[ chemistry.AcidDosingProcedure.DosingRows.length - 1 ].ToValue < chemistry.PHTarget
        )
    ) {
        errors.push(Locale.gettext("Based on your current Acid dosing table, you will never be able to reach your pH target of %s.", chemistry.PHTarget));
    }
    if (chemistry.DispensingBaseEnabled &&
        !chemistry.BaseDosingProcedureUseDefault && (
            !chemistry.BaseDosingProcedure?.DosingRows?.length ||
            chemistry.BaseDosingProcedure.DosingRows[ 0 ].FromValue > chemistry.PHTarget ||
            chemistry.BaseDosingProcedure.DosingRows[ chemistry.BaseDosingProcedure.DosingRows.length - 1 ].ToValue < chemistry.PHTarget
        )
    ) {
        errors.push(Locale.gettext("Based on your current Base dosing table, you will never be able to reach your pH target of %s.", chemistry.PHTarget));
    }
    if (chemistry.DispensingCO2Enabled &&
        !chemistry.CO2DosingProcedureUseDefault && (
            !chemistry.CO2DosingProcedure?.DosingRows?.length ||
            chemistry.CO2DosingProcedure.DosingRows[ 0 ].FromValue > chemistry.PHTarget ||
            chemistry.CO2DosingProcedure.DosingRows[ chemistry.CO2DosingProcedure.DosingRows.length - 1 ].ToValue < chemistry.PHTarget
        )
    ) {
        errors.push(Locale.gettext("Based on your current CO2 dosing table, you will never be able to reach your pH target of %s.", chemistry.PHTarget));
    }

    if (chemistry.DispensingLiquidChlorineEnabled &&
        !chemistry.LiquidChlorineDosingProcedureUseDefault && (
            !chemistry.LiquidChlorineDosingProcedure?.DosingRows?.length ||
            chemistry.LiquidChlorineDosingProcedure.DosingRows[ 0 ].FromValue > chemistry.SanitizerTarget?.Target ||
            chemistry.LiquidChlorineDosingProcedure.DosingRows[ chemistry.LiquidChlorineDosingProcedure.DosingRows.length - 1 ].ToValue < chemistry.SanitizerTarget?.Target
        )
    ) {
        errors.push(Locale.gettext(
            "Based on your current Liquid Chlorine dosing table, you will never be able to reach your %1$s target of %2$d.",
            getSanitizerTypeLocalized(chemistry.SanitizerTarget?.Type) ?? Locale.gettext("sanitizer"),
            chemistry.SanitizerTarget?.Target
        ));
    }
    if (chemistry.DispensingSaltChlorineEnabled &&
        chemistry.SaltChlorineDosing?.NotCovered?.SaltChlorinatorDispenseMethod !== SaltChlorineDispenseMethods.MANUAL_PERCENT &&
        !chemistry.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault && (
            !chemistry.SaltChlorineDosing?.NotCovered?.DosingRows?.length ||
            chemistry.SaltChlorineDosing.NotCovered.DosingRows[ 0 ].FromValue > chemistry.SanitizerTarget?.Target ||
            chemistry.SaltChlorineDosing.NotCovered.DosingRows[ chemistry.SaltChlorineDosing.NotCovered.DosingRows.length - 1 ].ToValue < chemistry.SanitizerTarget?.Target
        )
    ) {
        errors.push(Locale.gettext(
            "Based on your current Salt Chlorination dosing table, you will never be able to reach your %1$s target of %2$d.",
            getSanitizerTypeLocalized(chemistry.SanitizerTarget?.Type) ?? Locale.gettext("sanitizer"),
            chemistry.SanitizerTarget?.Target
        ));
    }
    if (chemistry.DispensingSaltChlorineEnabled &&
        chemistry.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod !== SaltChlorineDispenseMethods.MANUAL_PERCENT &&
        !chemistry.SaltChlorineDosing?.Covered?.DosingRowsUseDefault &&
        chemistry.SaltChlorineDosing?.CoveredDosingProcedureEnabled && (
            !chemistry.SaltChlorineDosing?.Covered?.DosingRows?.length ||
            chemistry.SaltChlorineDosing.Covered.DosingRows[ 0 ].FromValue > chemistry.SanitizerTarget?.Target ||
            chemistry.SaltChlorineDosing.Covered.DosingRows[ chemistry.SaltChlorineDosing.Covered.DosingRows.length - 1 ].ToValue < chemistry.SanitizerTarget?.Target
        )
    ) {
        errors.push(Locale.gettext(
            "Based on your current Salt Chlorination dosing table, you will never be able to reach your %1$s target of %2$d when the cover is closed.",
            getSanitizerTypeLocalized(chemistry.SanitizerTarget?.Type) ?? Locale.gettext("sanitizer"),
            chemistry.SanitizerTarget?.Target
        ));
    }

    return errors.length && errors;
}

/**
 * Checks if all the parameters reqired for the Controller to return ChemistryEdit are set.
 * Then calls the passed in function that should do the Controller communications.
 */
export function validateGetDefaultChemistryConfigParams(
    chemistryEditFromState: ChemistryEdit,
    chemistryConfig: BowChemistry,
    chemistryVersion: number,
    autoFilterVersion: number,
    configData: HardwareConfig,
    getChemistryEditFromController: Function,
): ChemistryEdit | Promise<ChemistryEdit> {
    // Backward compatibility for old controllers not supporting Device.getDefaultChemistryConfig;
    if (autoFilterVersion < 34) {
        return chemistryEditFromState;
    }

    if (!chemistryConfig?.BodyOfWaterUUID) {
        const err = new Error("Missing parameter: BodyOfWaterUUID");
        throw err;
    }
    if (isSanitizationAvailable(
        chemistryVersion,
        chemistryEditFromState
    ) &&
    isSanitizerTargetAndAlertsAvailable(
        chemistryEditFromState,
        chemistryVersion,
        configData,
    )) {
        if (!isSet(chemistryConfig?.SanitizerTarget?.Target)) {
            // Somehow the migration did not run
            throw new PoolsideError(
                "Missing parameter: SanitizerTarget.Target",
                Locale.gettext("Missing Sanitizer Target. Please set it.")
            )
        }
        if (!isSet(chemistryConfig?.SanitizerTarget?.Type)) {
            // Somehow the migration did not run
            throw new PoolsideError(
                "Missing parameter: SanitizerTarget.Type",
                Locale.gettext("Missing Sanitizer Type. Please set one.")
            );
        }
    }
    if (isPhAvailable(
        chemistryVersion,
        chemistryEditFromState
    ) &&
    isPhTargetAndAlertsAvailable(
        chemistryEditFromState,
        chemistryVersion,
        configData,
    )) {
        if (!isSet(chemistryConfig?.PHTarget)) {
            // Somehow the migration did not run
            throw new PoolsideError(
                "Missing parameter: PHTarget",
                Locale.gettext("Missing pH Target. Please set it.")
            );
        }
    }

    if (!chemistryConfig?.SanitizerTarget && !chemistryConfig?.PHTarget) {
        // No SanitizerTarget nor PHTarget but this point still reached means they were not requested from the user.
        // Seems no target felds are visible e.g. the user does not have probes. Skip requesting dosing table form the controller.
        // It would require at least one of them.
        return chemistryEditFromState;
    }

    return getChemistryEditFromController();
}

/**
* Tells if the system supports pH. Can be used to show/hide pH configuration tab on the UI.
*/
export function isPhAvailable(chemistryVersion: number, chemistryEdit: ChemistryEdit) {
    return chemistryVersion >= 6 ?
        chemistryEdit.ShowEditingPhTab :
        (chemistryEdit.Acid || chemistryEdit.CO2)
    ;
}

/**
 * Tells if the system supports sanitization. Can be used to show/hide Sanitization configuration tab on the UI.
 */
export function isSanitizationAvailable(chemistryVersion: number, chemistryEdit: ChemistryEdit) {
    return chemistryVersion >= 6 ?
        chemistryEdit?.ShowEditingSanitizerTab :
        (
            chemistryEdit.SaltChlorine ||
            chemistryEdit.LiquidChlorine ||
            chemistryEdit.Ozone ||
            chemistryEdit.UvSanitizer
        )
    ;
}

/**
 * When user changes sanitizer type then the user made custom dosing procdeures could became invalid.
 * Only the procedure that uses/follows Controller default settings remains valid.
 * @returns
 * - False in case no need to alert the user and reset settings.
 * - Otherwise an object with localized alert title and alert message for the user.
 */
export function isClearingDosingProcedureNeededBecasueOfChangedSanitizerType(chemistryConfig: BowChemistry, newSanitizerType: SanitizerTypes): boolean | { title: string, message: string } {
    if (
        (
            !chemistryConfig.DispensingSaltChlorineEnabled ||
            chemistryConfig.SaltChlorineDosing?.NotCovered?.SaltChlorinatorDispenseMethod === SaltChlorineDispenseMethods.MANUAL_PERCENT || (
                chemistryConfig.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault &&
                (
                    !chemistryConfig.SaltChlorineDosing?.CoveredDosingProcedureEnabled ||
                    chemistryConfig.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod === SaltChlorineDispenseMethods.MANUAL_PERCENT ||
                    chemistryConfig.SaltChlorineDosing?.Covered?.DosingRowsUseDefault
                )
            )
        ) &&
        (
            !chemistryConfig.DispensingLiquidChlorineEnabled ||
            chemistryConfig.LiquidChlorineDosingProcedureUseDefault
        )
    ) {
        return false;
    }

    return ({
        title: Locale.gettext("Change Sanitizer Type to %s?",
            getSanitizerTypeLocalized(newSanitizerType)
        ),
        message: Locale.gettext("When changing sanitizer types, you will need to re-create any existing dosing tables for Salt and Liquid Chlorine, should they exist."),
    });
}

/**
 * Returns the changes needed for the passed in ChemistryConfig when sanitizer type changes.
 */
export function updateSanitizerTypes(newSanitizerType: SanitizerTypes, chemistryEdit: ChemistryEdit) {
    return ({
        // Updating target values to the defaults of the newly selected sanitizer type
        SanitizerTarget: {
            Target: getDefaultSanitizerTargetByType(newSanitizerType, chemistryEdit),
            Type: newSanitizerType
        },
        SanitizerAlertTooHigh: {
            Target: getDefaultSanitizerAlertTooHighTargetByType(newSanitizerType, chemistryEdit),
            Type: newSanitizerType
        },
        SanitizerAlertTooLow: {
            Target: getDefaultSanitizerAlertTooLowTargetByType(newSanitizerType, chemistryEdit),
            Type: newSanitizerType
        },
    });
}

/**
 * Returns the changes needed for the dosing procedure of the passed in ChemistryConfig after a sanitizer type change.
 * @see isClearingDosingProcedureNeededBecasueOfChangedSanitizerType
 */
export function resetDosingTableAccordingToSanitizerTypeChange(chemistryConfig: BowChemistry) {
    return {
        // Clearing dozing tables so defaults could be set when user enters the edit forms.
        LiquidChlorineDosingProcedure: chemistryConfig.LiquidChlorineDosingProcedure ?
            {
                ...chemistryConfig.LiquidChlorineDosingProcedure,
                DosingRows: undefined
            } :
            chemistryConfig.LiquidChlorineDosingProcedure
        ,

        SaltChlorineDosing: chemistryConfig.SaltChlorineDosing ?
            {
                ...chemistryConfig.SaltChlorineDosing,

                Covered: chemistryConfig.SaltChlorineDosing.Covered ?
                    {
                        ...chemistryConfig.SaltChlorineDosing.Covered,
                        DosingRows: undefined
                    } :
                    chemistryConfig.SaltChlorineDosing.Covered
                ,

                NotCovered: chemistryConfig.SaltChlorineDosing.NotCovered ?
                    {
                        ...chemistryConfig.SaltChlorineDosing.NotCovered,
                        DosingRows: undefined
                    } :
                    chemistryConfig.SaltChlorineDosing.NotCovered
                ,

            } :
            chemistryConfig.SaltChlorineDosing
        ,
    }
}

export function getDosingTableRestorationAlertDetails():
    { message: string, title: string, buttonRevert: string, buttonKeep: string }
{
    return {
        message: Locale.gettext("Would you like to keep the current default settings as your starting point, or revert to your previous settings?"),
        title: Locale.gettext("Use defaults as base?"),
        buttonRevert: Locale.gettext("Revert"),
        buttonKeep: Locale.gettext("Keep"),
    }
}

export function getSaltChlorineDispenseMethodLocalized(method: SaltChlorineDispenseMethods): string {
    switch (method) {
    case SaltChlorineDispenseMethods.MANUAL_PERCENT: return Locale.gettext('By Percent');
    case SaltChlorineDispenseMethods.MANUAL_PPM: return Locale.gettext('By PPM');
    case SaltChlorineDispenseMethods.AUTOMATIC_PROBE: return Locale.gettext('Automatic');
    case SaltChlorineDispenseMethods.DAILY_UV_INDEX: return Locale.gettext('Daily UV Index');
    case SaltChlorineDispenseMethods.HOURLY_UV_INDEX: return Locale.gettext('Hourly UV Index');
    default: return method;
    }
}

/**
 * Makes changes if needed and returns the modified newRecord.
 * If no changes, then returns false.
 * Also it might calls passed in done() asynchronously.
 */
export function onSaltChange(
    oldRecord: BowChemistry,
    newRecord: BowChemistry,
    chemistryEditFromController: ChemistryEdit,
    AutoFilterVersion: number,
    setOldNotCoveredDosingRows: Function,
    setOldCoveredDosingRows: Function,
    alertNotCoveredDosingTableRestoration: Function,
    alertCoveredDosingTableRestoration: Function,
) {
    let isChanged = false;
    function addChange(record) {
        isChanged = true;
        changedRecord = record;
    }
    let changedRecord = safeObjCopy(newRecord);

    const defaultNotCoveredDosingRows = chemistryEditFromController?.DefaultSaltDosingProcedure?.NotCovered?.DosingRows;
    const defaultNotCoveredDosingRowsCopy = defaultNotCoveredDosingRows ?
        safeArrCopy(defaultNotCoveredDosingRows) : undefined
    ;
    const defaultCoveredOrNotCoveredDosingRows = chemistryEditFromController?.DefaultSaltDosingProcedure?.Covered?.DosingRows
        ?? defaultNotCoveredDosingRows
    ;
    const defaultCoveredOrNotCoveredDosingCopy = defaultCoveredOrNotCoveredDosingRows ?
        safeArrCopy(defaultCoveredOrNotCoveredDosingRows) : undefined
    ;

    function modifyNotCovered(record, changes) {
        return {
            ...record,
            SaltChlorineDosing: {
                ...record.SaltChlorineDosing,
                NotCovered: {
                    ...record.SaltChlorineDosing?.NotCovered,
                    ...changes,
                }
            }
        }
    }

    function modifyCovered(record, changes) {
        return {
            ...record,
            SaltChlorineDosing: {
                ...record.SaltChlorineDosing,
                Covered: {
                    ...record.SaltChlorineDosing?.Covered,
                    ...changes,
                }
            }
        }
    }

    function setEmptyNotCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(record) {
        if (
            record.SaltChlorineDosing?.NotCovered?.SaltChlorinatorDispenseMethod &&
            record.SaltChlorineDosing.NotCovered.SaltChlorinatorDispenseMethod !== SaltChlorineDispenseMethods.MANUAL_PERCENT &&
            (
                // Using default is not false
                record.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault ||
                (typeof record.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault === "undefined" && !record.SaltChlorineDosing?.NotCovered?.DosingRows)
            ) &&
            !record.SaltChlorineDosing?.NotCovered?.DosingRows
        ) {
            // Turn on using default and set default dosing
            return modifyNotCovered(record, {
                DosingRowsUseDefault: AutoFilterVersion >= 34,
                DosingRows: defaultNotCoveredDosingRowsCopy,
            });
        } else {
            return record;
        }
    }

    function setEmptyCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(record) {
        if (
            record.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod &&
            record.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod !== SaltChlorineDispenseMethods.MANUAL_PERCENT && (
                record.SaltChlorineDosing?.Covered?.DosingRowsUseDefault ||
                (typeof record.SaltChlorineDosing?.Covered?.DosingRowsUseDefault === "undefined" && !record.SaltChlorineDosing?.Covered?.DosingRows)
            ) &&
            !record.SaltChlorineDosing?.Covered?.DosingRows
        ) {
            // Turning on using default for covered and set default dosing
            return modifyCovered(record, {
                DosingRowsUseDefault: AutoFilterVersion >= 34,
                DosingRows: defaultCoveredOrNotCoveredDosingCopy,
            });
        } else {
            return record;
        }
    }


    // Dispensing Chlorine toggled on?
    if (newRecord.DispensingSaltChlorineEnabled !== oldRecord.DispensingSaltChlorineEnabled &&
        newRecord.DispensingSaltChlorineEnabled
    ) {
        // Set not-covered defaults
        addChange(setEmptyNotCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(changedRecord));
        if (newRecord.SaltChlorineDosing?.CoveredDosingProcedureEnabled) {
            // Set covered defaults
            addChange(setEmptyCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(changedRecord));
        }
    }

    // Not-covered method changed?
    if (newRecord.SaltChlorineDosing?.NotCovered?.SaltChlorinatorDispenseMethod !== oldRecord?.SaltChlorineDosing?.NotCovered?.SaltChlorinatorDispenseMethod) {
        addChange(setEmptyNotCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(changedRecord));
    }

    // Not-covered use default toggled?
    if (newRecord.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault !== oldRecord.SaltChlorineDosing?.NotCovered?.DosingRowsUseDefault) {
        if (newRecord.SaltChlorineDosing.NotCovered.DosingRowsUseDefault) {
            // Toggled on. Back up custom dosing and set default dosing
            setOldNotCoveredDosingRows(changedRecord.SaltChlorineDosing?.NotCovered?.DosingRows ?
                safeArrCopy(changedRecord.SaltChlorineDosing.NotCovered.DosingRows) : undefined
            );
            addChange(modifyNotCovered(changedRecord, {
                DosingRows: defaultNotCoveredDosingRowsCopy,
            }));
        } else {
            // Ask to revert old dosing table if any
            alertNotCoveredDosingTableRestoration(oldNotCoveredDosingRows =>
                modifyNotCovered(changedRecord, {
                    DosingRows: oldNotCoveredDosingRows,
                })
            );
        }
    }

    if (
        (   // Dispensing Covered Chlorine toggled on?
            newRecord.SaltChlorineDosing?.CoveredDosingProcedureEnabled !== oldRecord.SaltChlorineDosing?.CoveredDosingProcedureEnabled &&
            newRecord.SaltChlorineDosing?.CoveredDosingProcedureEnabled
        ) ||
        // Covered method changed?
        (newRecord.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod !== oldRecord.SaltChlorineDosing?.Covered?.SaltChlorinatorDispenseMethod)
    ) {
        addChange(setEmptyCoveredDosingRowsToDefaultIfUseDefaultAndMethodAuto(changedRecord));
    }
    
    // Covered use default toggled?
    if (newRecord.SaltChlorineDosing?.Covered?.DosingRowsUseDefault !== oldRecord.SaltChlorineDosing?.Covered?.DosingRowsUseDefault) {
        if (newRecord.SaltChlorineDosing?.Covered?.DosingRowsUseDefault) {
            // Toggled on. Back up custom dosing and set default dosing
            setOldCoveredDosingRows(changedRecord.SaltChlorineDosing?.Covered?.DosingRows ?
                safeArrCopy(changedRecord.SaltChlorineDosing.Covered.DosingRows) : undefined
            );
            addChange(modifyCovered(changedRecord, {
                DosingRows: defaultCoveredOrNotCoveredDosingCopy,
            }));
        } else {
            // Ask to revert old dosing table if any
            alertCoveredDosingTableRestoration(oldCoveredDosingRows =>
                modifyCovered(changedRecord, {
                    DosingRows: oldCoveredDosingRows,
                })
            );
        }
    }

    return isChanged ? changedRecord : false;
}

/**
 * @param {CoreParams} coreParams
 * @param {object} busClassItem Item from getPortUsage()
 * {
 *   BusClassName: "GoldlineBus",
 *   ConfiguredDevices: [
 *       {
 *           UUID: "9e6902fc-7f06-4f1d-92eb-12aSALTCELL1",
 *           Addresses: [
 *               "1"
 *           ],
 *           AddressUniqueType: null,
 *           Invalid: true,
 *           InvalidReason: "E.g: device address is not unique"
 *       }
 *   ]
 * }
 * @returns {Object|undefined} Conflicted addresses grouped by addressUniqueType E.g:
 * {
 *   pump: { Addresses: [ "addr1", "addr4" ] }, // Means there are more than one addr1 and more than one addr4 configured for "pump" busClass
 *   "": { Addresses: [ "addr2", "addr4" ] }, // Means there are more than one addr2 and more than one addr4 configured for "" busClass
 *   saltCell: { Addresses: [ "" ] } // Means there are more than one empty address is configured on the "saltCell" busClass
 * }
 */
export function getConflictingAddressesByAddressUniqueType(coreParams: CoreParams, busClassItem: PortUsageBusClasses, site):
    { [ key: string ]: PortUsageInvalidAddressesByAddressUiqueType } | undefined
{
    if (!coreParams?.configData) throw new MissingCoreParamsError();

    // A device address should be obviously unique on a given Controller - Module - Serial port. busClassItem contains only these devices.
    // Additionally, on the given serial port, address should be unique among the devices with the same busClass and same addressUniqueType
    // Empty addressUniqueType or empty address count too so there could be only one device without address on the same busClass    
    
    const conflictingAddressesByAddressUniqueType = {};
    busClassItem.ConfiguredDevices?.forEach(configuredDevice => {
        // Treat device without address as having an empty string as address
        const configuredDeviceAddresses = (configuredDevice.Addresses?.length ? configuredDevice.Addresses : [ { Address: "" } ]);
        configuredDeviceAddresses.forEach((itemConfiguredDeviceAddress, idxConfiguredDeviceAddress) => {
            const otherDevices = busClassItem.ConfiguredDevices.filter(item => (item.AddressUniqueType || "") === (configuredDevice.AddressUniqueType || ""));

            otherDevices.forEach(itemOtherDevice => {
                (itemOtherDevice?.Addresses || [ { Address: "" } ]).forEach((itemOtherDeviceAddress, idxOtherDeviceAddress) => {
                    if (
                        (itemOtherDeviceAddress.Address ?? "") === (itemConfiguredDeviceAddress.Address ?? "") &&
                        // Same device same connection e.g checking DMXLight1 Red address against DMXLight1 Red address.
                        // It should not be treated as duplicated address
                        !(
                            configuredDevice.UUID === itemOtherDevice.UUID &&
                            idxConfiguredDeviceAddress === idxOtherDeviceAddress
                        )
                    ) {
                        const addressUniqueType = configuredDevice.AddressUniqueType || ""
                        if (!conflictingAddressesByAddressUniqueType[ addressUniqueType ]) {
                            conflictingAddressesByAddressUniqueType[ addressUniqueType ] = {
                                Addresses: [],
                            };
                        }
                        if (!conflictingAddressesByAddressUniqueType[ addressUniqueType ]?.Addresses?.includes(itemConfiguredDeviceAddress.Address ?? "")) {   
                            conflictingAddressesByAddressUniqueType[ addressUniqueType ].Addresses.push(itemConfiguredDeviceAddress.Address ?? "");
                        }
                        const { configurableFields } = getDeviceBusInfo(
                            coreParams.configData.Devices?.find(item => item.UUID === configuredDevice.UUID),
                            site
                        );
                        if (!configurableFields?.length) {
                            conflictingAddressesByAddressUniqueType[ addressUniqueType ].nonfixable = true;
                        }
                    }
                })
            });
        });
    });

    if (Object.values(conflictingAddressesByAddressUniqueType).length) {
        return conflictingAddressesByAddressUniqueType;
    }
    
}

/**
 * Gets platform capabilities and augment it by the hw config.
 * @param coreParams
 * @returns E.g:
 * {
 *     Controllers: [
 *         {
 *             ControllerUUID: "a0a92c3a-a681-47fd-bde6-d963415b0b54",
 *             Modules: [
 *                 {
 *                     ModuleNumber: "1",
 *                     PortTypes: {
 *                         Bus: [
 *                             {
 *                                 PortNumber: 1,
 *                                 BusClasses: [
 *                                     {
 *                                         BusClassName: "GoldlineBus",
 *                                         ConfiguredDevices: [
 *                                             {
 *                                                 UUID: "9e6902fc-7f06-4f1d-92eb-12aSALTCELL1",
 *                                                 Addresses: [
 *                                                     { Address: "1" }
 *                                                 ],
 *                                                 AddressUniqueType: null,
 *                                                 Invalid: true,
 *                                                 InvalidReason: "E.g: device address is not unique"
 *                                             }
 *                                         ],
 *                                         Invalid: true,
 *                                         InvalidReason: "E.g: device bus class is not cohabitatable"
 *                                     }
 *                                 ]
 *                             }
 *                         ],
 *                         "LowVoltage": [
 *                             {
 *                                 "PortNumber": 1,
 *                                 "ConfiguredDevices": [
 *                                     {
 *                                         "UUID": "d17f728d-0a3e-41b6-9121-123f70HEATER"
 *                                     }
 *                                 ]
 *                             },
 *                             {
 *                                 "PortNumber": 2,
 *                                 "ConfiguredDevices": [
 *                                     {
 *                                         "UUID": "1fb7f3f4-b331-4ff1-8dd1-FILTER1RETUR"
 *                                     }
 *                                 ]
 *                             },
 *                             {
 *                                 "PortNumber": 3
 *                             }
 *                         ],
 *                         "Bluetooth": [
 *                             {
 *                                 "ConfiguredDevices": [
 *                                       {
 *                                            "UUID": "1e9c954f-796f-421f-830f-285971a091d7",
 *                                            "Addresses": [
 *                                                "04:EE:03:DB:5E:94"
 *                                            ]
 *                                       }
 *                                 ]
 *                             }
 *                         ]
 *                     }
 *                 }
 *             ]
 *         }
 *     ]
 * }
 */
export function getPortUsage(coreParams: CoreParams, site: SiteRecord): PortUsage {
    if (!coreParams?.configs && !coreParams?.configData) throw new MissingCoreParamsError();
    if (!coreParams?.siteStates) throw new MissingCoreParamsError();

    const configData: HardwareConfig = (coreParams.configs?.find(
        item => item.fileName === ConfigRecordFileNames.HardwareConfig
    ))?.data
        ?? coreParams.configData
    ;

    const siteStates = coreParams.siteStates;

    const platformCapabilities = safeJsonParse(siteStates.PlatformCapabilities || "{}") as PlatformCapabilities;
    if (!platformCapabilities?.Controllers) {
        Logger.warn("[Api.Config] getPortUsage() No PlatformCapabilities. Available siteStates:", Object.keys(siteStates || {}));
        // globals.toastIcon("warn", Locale.gettext("No platform capabilities info available."));
    }
    
    const primaryControllerUuid = configData.Controllers && configData.Controllers[0]?.UUID;
    if (!primaryControllerUuid) {
        Logger.warn("[Api.Config] getPortUsage() No primary controller in config. configData:", Object.keys(configData || {}))
        // globals.toastIcon("warn", Locale.gettext("No primary controller in config."));
    }

    const portUsage = safeObjCopy(platformCapabilities) as PortUsage;

    portUsage?.Controllers?.forEach(controller => {
        controller.Modules.forEach(module => {
            
            // @todo remove once controller supports it
            if (!module.PortTypes.ChemistryORP) {
                module.PortTypes.ChemistryORP = [
                    {
                        PortNumber: 1

                    },
                    {
                        PortNumber: 2
                    }
                ];
            }
            if (!module.PortTypes.ChemistryPH) {
                module.PortTypes.ChemistryPH = [
                    {
                        PortNumber: 1

                    },
                    {
                        PortNumber: 2
                    }
                ];
            }
            if (!module.PortTypes.Bluetooth) {
                module.PortTypes.Bluetooth = [
                    {
                    
                    }
                ];
            }
            
            Object.entries(module.PortTypes).forEach(([ portType, ports ]) => {
                ports.forEach(port => {
                    const devices = [];
                    configData.Devices
                        ?.forEach(device => {
                            const devicePorts = getDevicePorts(device);
                            if (
                                controller.ControllerUUID === (device.HardwareDevice?.Controller ?? primaryControllerUuid) &&
                                module.ModuleNumber === (device.HardwareDevice?.Module ?? "1")
                            ) {
                                devicePorts.forEach(itemDevicePort => {
                                    if (
                                        translatePortTypeHwConfigToPlatformCapabilities(itemDevicePort.Type) === portType &&
                                        (portType === 'Bluetooth' || itemDevicePort.Number === port.PortNumber)
                                    ) {
                                        devices.push(device);
                                    }
                                })
                            }
                        })
                    ;


                    devices?.length && devices.forEach((device, idx) => {
                        if (portType === 'Bus') {
                            const { deviceBusClass, addressUniqueType, addresses } = getDeviceBusInfo(device, site);

                            let busClassItem = (port as PortUsagePortsBus).BusClasses?.find(item => item.BusClassName === deviceBusClass);
                            if (!busClassItem) {
                                busClassItem = { BusClassName: deviceBusClass, ConfiguredDevices: [] };
                                if (!(port as PortUsagePortsBus).BusClasses) {
                                    (port as PortUsagePortsBus).BusClasses = [];
                                }
                                (port as PortUsagePortsBus).BusClasses.push(busClassItem);
                            }

                            const busClassItemDevice = {
                                UUID: device.UUID,
                                Addresses: addresses.length ? addresses.map(item => ({ Address: item })) : undefined,
                                AddressUniqueType: addressUniqueType
                                /*
                                Addresses: (addresses.length ? addresses : [ "" ]).map(item => ({ Address: item })),
                                AddressUniqueType: addressUniqueType ?? ""
                                */
                            };
                            busClassItem.ConfiguredDevices.push(busClassItemDevice);
                        } else if (portType === 'Bluetooth') {
                            if (!port.ConfiguredDevices) {
                                port.ConfiguredDevices = [];
                            }

                            const configuredDeviceItem = {
                                UUID: device.UUID,
                                Addresses: [ { Address: device.HardwareDevice?.UniqueBusIdentifier } ]
                            };
                            port.ConfiguredDevices.push(configuredDeviceItem);
                        } else {
                            if (!port.ConfiguredDevices) {
                                port.ConfiguredDevices = [];
                            }

                            const configuredDeviceItem = {
                                UUID: device.UUID
                            };
                            

                            getDevicePortBookingType(
                                device,
                                {
                                    Type: translatePortTypePlatformCapabilitiesToHwConfigTo(portType as PlatformCapabilitiesModulesPortTypes), Number: port.PortNumber
                                }
                            )?.forEach(item => {
                                if (!(port as PortUsagePortsRelay).BookedAs?.includes(item)) {
                                    if (!(port as PortUsagePortsRelay).BookedAs) {
                                        (port as PortUsagePortsRelay).BookedAs = [];
                                    }
                                    (port as PortUsagePortsRelay).BookedAs.push(item)
                                }
                            })
                            
                            // Intentionally allow the same device to be added multiple times
                            // No condition like: `if (!port.ConfiguredDevices.some(item => item.UUID === configuredDeviceItem.UUID))...`
                            // This helps detecting an invalid case when the same devce was added multiple times booking the same port as connect port
                            port.ConfiguredDevices.push(configuredDeviceItem);
                        }
                    });    

                });
            });


            Object.entries(module.PortTypes).forEach(([ portType, ports ]) => {
                ports.forEach(port => {
                    if (portType === 'Bus') {
                        (port as PortUsagePortsBus).BusClasses?.forEach(busClassItem => {
                            if (!areBusClassesCompatibleOnPort({ configData: configData, siteStates }, port)) {
                                portUsage.Invalid = true;
                                port.Invalid = true;
                                port.InvalidReason = 'Bus classes are not cohabitatable:' +
                                    ' ' + (port as PortUsagePortsBus).BusClasses?.map(item => item.BusClassName).join(', ');
                            }
                            
                            const conflictingAddressesByAddressUiqueType = getConflictingAddressesByAddressUniqueType({ configData }, busClassItem, site);
                            if (conflictingAddressesByAddressUiqueType) {
                                portUsage.Invalid = true;
                                busClassItem.Invalid = true;
                                busClassItem.InvalidReason = Locale.gettext(
                                    'The following addresses are not unique: %s',
                                    Object.entries(conflictingAddressesByAddressUiqueType).map(([ key, value ]) =>
                                        "[" + (key || "emptyaddressuniquetype") + ': ' + value.Addresses.map(item => item || "emptyaddress").join(', ') + " ]"
                                    ).join(', '),
                                
                                )
                                busClassItem.InvalidAddressesByAddressUiqueType = conflictingAddressesByAddressUiqueType;
                            }
                        });
                    } else if (portType === 'Bluetooth') {
                        const conflictingAddresses = [];
                        port.ConfiguredDevices?.forEach(itemConfiguredDevice => {
                            (itemConfiguredDevice.Addresses || [ { Address: "" } ]).forEach((itemConfiguredDeviceAddress, idxConfiguredDeviceAddress) => {
                                if (port.ConfiguredDevices.some(itemOtherConfiguredDevice =>
                                    itemOtherConfiguredDevice.Addresses.some((item, idx) =>
                                        item.Address === itemConfiguredDeviceAddress.Address &&
                                        !(itemConfiguredDevice.UUID === itemOtherConfiguredDevice.UUID && idxConfiguredDeviceAddress === idx)
                                    )
                                )) {
                                    if (!conflictingAddresses.includes(itemConfiguredDeviceAddress.Address || "")) {
                                        conflictingAddresses.push(itemConfiguredDeviceAddress.Address || "");
                                    }
                                }
                            });
                        })

                        if (conflictingAddresses.length) {
                            portUsage.Invalid = true;
                            port.Invalid = true;
                            port.InvalidReason = Locale.gettext('Address is not unique: %s', conflictingAddresses.join(', '));
                            port.InvalidAddresses = conflictingAddresses;
                        }
                    } else {
                        if ((port as PortUsagePortsRelay).BookedAs?.length > 1) {
                            portUsage.Invalid = true;
                            port.Invalid = true;
                            port.InvalidReason = Locale.gettext('A control port already assigned to one device cannot be reassigned or shared as a Power Port for another device.');
                        } else if (port.ConfiguredDevices?.length > 1
                            && (!(port as PortUsagePortsRelay).BookedAs?.includes(PortUsagePortBookingType.PowerPort))
                        ) {
                            portUsage.Invalid = true;
                            port.Invalid = true;
                            port.InvalidReason = Locale.gettext('Only one device is allowed per control port.');
                        }

                    }
                });
            });
        });
    });

    return portUsage;
}

/**
 * Location of Ports array is different within the device config and depends on the device type.
 * This function looks it up in all possible locations and returns them.
 * @param device 
 * @returns
 * @see getAllPortTypes()
 */
export function getDevicePorts(device: DeviceConfig): PortConfig[] {
    return [
        ...(device?.HardwareDevice?.Ports || []),
        device?.HardwareDevice?.WaterLevelSensorSettings?.WaterLevelSensor,
        device?.HardwareDevice?.WaterLevelSensorSettings?.PoweringWaterLevelSensor,
        device?.HardwareDevice?.AutoFillSettings?.SolenoidValve,
        device?.HardwareDevice?.PowerPort,
    ]?.filter(item => (item?.Type || item?.Number)); 
}

/**
 * Looks up `port` in `device` and returns all the purposes of the port bookings.
 * @param device 
 * @param port 
 * @returns 
 */
export function getDevicePortBookingType(device: DeviceConfig, port: PortConfig): PortUsagePortBookingType[] {
    const bookingType: PortUsagePortBookingType[] = [];

    function extend(type: PortUsagePortBookingType): void {
        if (!bookingType.some(item => item === type)) bookingType.push(type);
    }

    if (device.HardwareDevice?.Ports?.some(item => item.Type === port.Type && item.Number === port.Number)) {
        extend(PortUsagePortBookingType.ControlPort);
    }

    if (device.HardwareDevice?.PowerPort?.Type === port.Type
        && device.HardwareDevice?.PowerPort?.Number === port.Number
    ) {
        extend(PortUsagePortBookingType.PowerPort);
    }

    if (device.HardwareDevice?.WaterLevelSensorSettings?.WaterLevelSensor?.Type === port.Type
        && device.HardwareDevice?.WaterLevelSensorSettings?.WaterLevelSensor?.Number === port.Number
    ) {
        extend(PortUsagePortBookingType.ControlPort);
    }
    if (device.HardwareDevice?.WaterLevelSensorSettings?.PoweringWaterLevelSensor?.Type === port.Type
        && device.HardwareDevice?.WaterLevelSensorSettings?.PoweringWaterLevelSensor?.Number === port.Number
    ) {
        extend(PortUsagePortBookingType.PowerPort);
    }

    if (device.HardwareDevice?.AutoFillSettings?.SolenoidValve?.Type === port.Type
        && device.HardwareDevice?.AutoFillSettings?.SolenoidValve.Number === port.Number
    ) {
        extend(PortUsagePortBookingType.ControlPort);
    }

    return bookingType;
}



/**
 * 
 * @param hwConfigPort Port type name in Hardware Config E.g: Serial
 * @returns Port type name in Platform Capabilities E.g: Bus
 */
export function translatePortTypeHwConfigToPlatformCapabilities(hwConfigPort: PortTypeValues): PlatformCapabilitiesModulesPortTypes {
    switch (hwConfigPort) {
    case PortTypeValues.Actuator: return PlatformCapabilitiesModulesPortTypes.Actuator;
    case PortTypeValues.Bluetooth: return PlatformCapabilitiesModulesPortTypes.Bluetooth;
    case PortTypeValues.Chemistry420: return PlatformCapabilitiesModulesPortTypes.Ma;
    case PortTypeValues.ChemistryORP: return PlatformCapabilitiesModulesPortTypes.ChemistryORP;
    case PortTypeValues.ChemistryPH: return PlatformCapabilitiesModulesPortTypes.ChemistryPH;
    case PortTypeValues.HighVoltage: return PlatformCapabilitiesModulesPortTypes.HighVoltage;
    case PortTypeValues.InterfaceButtons: return PlatformCapabilitiesModulesPortTypes.InterfaceButtons;
    case PortTypeValues.LightDriverLowVoltage: return PlatformCapabilitiesModulesPortTypes.LightDriverLowVoltage;
    case PortTypeValues.LowVoltage: return PlatformCapabilitiesModulesPortTypes.LowVoltage;
    case PortTypeValues.PoolsideButtonInterface: return PlatformCapabilitiesModulesPortTypes.InterfaceButtons;
    case PortTypeValues.Serial: return PlatformCapabilitiesModulesPortTypes.Bus;
    case PortTypeValues.Switch: return PlatformCapabilitiesModulesPortTypes.FlowSwitch;
    case PortTypeValues.Thermistor: return PlatformCapabilitiesModulesPortTypes.Thermistor;
    default: return hwConfigPort;
    }
}

/**
 * @param  Port type name in Platform Capabilities E.g: Bus
 * @returns hwConfigPort Port type name in Hardware Config E.g: Serial
 */
export function translatePortTypePlatformCapabilitiesToHwConfigTo(platformCapabilitiesPort: PlatformCapabilitiesModulesPortTypes): PortTypeValues {
    switch (platformCapabilitiesPort) {
    case PlatformCapabilitiesModulesPortTypes.Actuator: return PortTypeValues.Actuator;
    case PlatformCapabilitiesModulesPortTypes.Bluetooth: return PortTypeValues.Bluetooth;
    case PlatformCapabilitiesModulesPortTypes.Bus: return PortTypeValues.Serial;
    case PlatformCapabilitiesModulesPortTypes.ChemistryORP: return PortTypeValues.ChemistryORP;
    case PlatformCapabilitiesModulesPortTypes.ChemistryPH: return PortTypeValues.ChemistryPH;
    case PlatformCapabilitiesModulesPortTypes.FlowSwitch: return PortTypeValues.Switch;
    case PlatformCapabilitiesModulesPortTypes.HighVoltage: return PortTypeValues.HighVoltage;
    case PlatformCapabilitiesModulesPortTypes.InterfaceButtons: return PortTypeValues.InterfaceButtons;
    case PlatformCapabilitiesModulesPortTypes.LightDriverLowVoltage: return PortTypeValues.LightDriverLowVoltage;
    case PlatformCapabilitiesModulesPortTypes.LowVoltage: return PortTypeValues.LowVoltage;
    case PlatformCapabilitiesModulesPortTypes.Ma: return PortTypeValues.Chemistry420;
    case PlatformCapabilitiesModulesPortTypes.Thermistor: return PortTypeValues.Thermistor;
    default: return platformCapabilitiesPort;
    }
}

/**
 * @param {Device} device 
 * @returns {object} E.g:
 * {
 *   deviceBusClass: "PentairBus",
 *   addressUniqueType: "Pump",
 *   addresses: [],
 *   configurableFields: [ {
 *     Name: "Address",
 *     Id: "UniqueBusIdentifier",
 *     Pattern: "1-16",
 *     Regex: "/^1[0-6]$|^[1-9]$/",
 *     Default: "1"
 *    } ]
 * }
 */
export function getDeviceBusInfo(device: DeviceConfig, site) {
    let deviceBusClass;
    let addressUniqueType;
    let addresses = [];
    let configurableFields = [];
    let deviceInfo;

    switch (device.DeviceType) {
    case DeviceTypes.CHLORINESENSOR: deviceInfo = Catalog.getChlorineSensorCatalogEntry(device?.HardwareDevice?.PrimaryCatalogId); break;
    case DeviceTypes.DISSOLVEDOXYGENSENSOR: deviceInfo = Catalog.getDissolvedOxygenSensorCatalogEntry(device?.HardwareDevice?.PrimaryCatalogId); break;
    case DeviceTypes.PUMP: deviceInfo = Catalog.Functions.getPumpInfo(device, site); break;
    case DeviceTypes.LIGHT: deviceInfo = Catalog.Functions.getLightInfo(device.HardwareDevice?.LightSettings, site); break;
    case DeviceTypes.LIGHTDRIVER: deviceInfo = Catalog.Functions.getLightDriverCatalog()
        ?.find(item => item.itemId === device.HardwareDevice?.PrimaryCatalogId);
        break;
    case DeviceTypes.CHILLER:
    case DeviceTypes.HEATER:
    case DeviceTypes.HEATPUMP:
        deviceInfo = Catalog.Functions.getHeaterInfo(device, site);
        break;
    case DeviceTypes.SALTCELL: deviceInfo = Catalog.Functions.getSaltCellCatalogEntry(device.HardwareDevice?.PrimaryCatalogId, device.HardwareDevice?.SecondaryCatalogId, site); break;
    case DeviceTypes.REMOTE: deviceInfo = Catalog.Functions.getRemoteCatalog()
        ?.find(item => item.itemId === device.HardwareDevice?.PrimaryCatalogId);
        break;
    case DeviceTypes.PRESSURESENSOR: {
        deviceInfo = Catalog.Functions.getPressureSensorInfo(device?.HardwareDevice.PrimaryCatalogId);
    } break;
    }

    switch (device.DeviceType) {
    case DeviceTypes.CHILLER:
    case DeviceTypes.CHLORINESENSOR:
    case DeviceTypes.DISSOLVEDOXYGENSENSOR:
    case DeviceTypes.HEATER:
    case DeviceTypes.HEATPUMP:
    case DeviceTypes.LIGHTDRIVER:
    case DeviceTypes.PRESSURESENSOR:
    case DeviceTypes.PUMP:
    case DeviceTypes.REMOTE:
        deviceBusClass = deviceInfo?.busClass;
        addressUniqueType = deviceInfo?.addressUniqueType;
        addresses = (device.HardwareDevice?.UniqueBusIdentifier && [ device.HardwareDevice?.UniqueBusIdentifier ]) || [];
        configurableFields = deviceInfo?.configurableFields || [];
        break;
    case DeviceTypes.LIGHT:
        deviceBusClass = deviceInfo?.colorAndShowLibrary?.busClass;
        addressUniqueType = deviceInfo?.addressUniqueType;
        addresses = ((device.HardwareDevice?.AddressMap && Object.values(device.HardwareDevice.AddressMap)) || []).map(item => Number(item));
        configurableFields = deviceInfo?.colorAndShowLibrary?.configurableFields || [];
        break;
    case DeviceTypes.SALTCELL:
        deviceBusClass = deviceInfo?.model?.busClass;
        addressUniqueType = deviceInfo?.model?.addressUniqueType;
        addresses = (device.HardwareDevice?.UniqueBusIdentifier && [ device.HardwareDevice?.UniqueBusIdentifier ]) || [];
        configurableFields = deviceInfo?.model?.configurableFields || [];
        break;
    }

    return ({
        deviceBusClass,
        addressUniqueType,
        addresses,
        configurableFields
    });
}

/**
 * @param {CoreParams} coreParams
 * Checks compatibility of the busclasses of a given serial port
 * @param {object} port E.g: item from return value of getPortUsage()
 * {
 *    PortNumber: 1,
 *    BusClasses: [ {
 *      BusClassName: "GoldlineBus",
 *      ConfiguredDevices: [
 *        {
 *          UUID: "9e6902fc-7f06-4f1d-92eb-12aSALTCELL1",
 *          Addresses: [
 *             "1"
 *          ],
 *          AddressUniqueType: null,
 *          Invalid: true,
 *          InvalidReason: "E.g: device address is not unique"
 *        }
 *      ],
 *      Invalid: true,
 *      InvalidReason: "E.g: device bus class is not cohabitatable"
 *  } ]
 * }
 * @returns {boolean}
 */
export function areBusClassesCompatibleOnPort(coreParams, port) {
    if (!coreParams?.configData) throw new MissingCoreParamsError();
    if (!coreParams?.siteStates) throw new MissingCoreParamsError();

    /** E.g:
     * [
     *   [ "GoldlineBus", "JandyBus" ],
     *   [ "GoldlineBus", "PentairBus" ]
     * ]
     */
    const cohabitableBuses = safeJsonParse(coreParams.siteStates.CohabitableBuses ?? "[]");
    const portBusClasses = (port.BusClasses ?? []);
    
    if (portBusClasses?.length <= 1) return true;

    // Is there a line in cohabitableBuses that includes all bus classes of the port
    return (cohabitableBuses.length && cohabitableBuses.some(itemCohabitableBuses =>
        // No item in portBusClasses that is not included in itemCohabitableBuses
        !portBusClasses.some(item => !itemCohabitableBuses.includes(item.BusClassName))
    ));
}

/**
 * Sort BOWs decreasing according to SizeGallon
 * For same SizeGallon, alphabetically sort by name
 */
export function getBodiesOfWaterSorted(coreParams: CoreParams): BodyOfWaterConfig[] {
    if (!coreParams) throw new MissingCoreParamsError();
    
    const hardwareConfig: HardwareConfigRecord = coreParams.configs?.find(
        item => item.fileName === ConfigRecordFileNames.HardwareConfig
    );
    
    return hardwareConfig?.data?.BodiesOfWater.sort((aBody, bBody) => {
        const sizeA = Number(aBody?.SizeGallons ?? 0);
        const sizeB = Number(bBody?.SizeGallons ?? 0);

        if (sizeA !== sizeB) {
            return sizeB - sizeA;
        }

        const nameA = aBody?.Name ?? "";
        const nameB = bBody?.Name ?? "";
        return nameA.localeCompare(nameB);
    });
}

